import { icons } from '@shared/static/icons';

export default function EmptyData({ text }) {
  return (
    <div className="empty-data">
      {icons['empty-data']}
      <p className="body-18m">{text}</p>
    </div>
  );
}
